import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaVideo, FaLeaf, FaHeart } from 'react-icons/fa';

const FeaturesContainer = styled.div`
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

const FeaturesH1 = styled.h2`
  font-size: 2.5rem;
  color: #1A365D;
  font-family: 'Playfair Display', serif;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const FeaturesWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const FeatureCard = styled(motion.div)`
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
  border-top: 5px solid #4CAF50;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const FeatureIcon = styled.div`
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #1A365D;
  color: #fff;
  font-size: 2rem;
`;

const FeatureH2 = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 10px;
  font-family: 'Playfair Display', serif;
  color: #1A365D;
  text-align: center;
`;

const FeatureP = styled.p`
  font-size: 1rem;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  color: #333;
  line-height: 1.5;
`;

const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 1px;
    background: #e0e0e0;
  }
`;

const Features = () => {
  return (
    <FeaturesContainer id="features">
      <TitleWrapper>
        <FeaturesH1>Nossos Diferenciais</FeaturesH1>
      </TitleWrapper>
      <FeaturesWrapper>
        <FeatureCard
          whileHover={{ y: -10 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <FeatureIcon>
            <FaVideo />
          </FeatureIcon>
          <FeatureH2>Velório Online</FeatureH2>
          <FeatureP>
            Sistema moderno que permite aos familiares que não podem estar presentes acompanhar a cerimônia em tempo real, com acessos ilimitados e compatível com qualquer dispositivo.
          </FeatureP>
        </FeatureCard>
        <FeatureCard
          whileHover={{ y: -10 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <FeatureIcon>
            <FaLeaf />
          </FeatureIcon>
          <FeatureH2>Cerimônias Personalizadas</FeatureH2>
          <FeatureP>
            Oferecemos cerimônias personalizadas com homenagens especiais, incluindo chuva de pétalas e revoada de pombos brancos, proporcionando um momento de despedida único e emocionante.
          </FeatureP>
        </FeatureCard>
        <FeatureCard
          whileHover={{ y: -10 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <FeatureIcon>
            <FaHeart />
          </FeatureIcon>
          <FeatureH2>Estrutura Completa</FeatureH2>
          <FeatureP>
            Contamos com capelas para cerimônias, espaços para reflexão, cafeteria, suítes para familiares, amplo estacionamento e até mesmo memorial para pequenos animais.
          </FeatureP>
        </FeatureCard>
      </FeaturesWrapper>
    </FeaturesContainer>
  );
};

export default Features;
